import React from 'react';
import {Button} from 'antd';
import { PlusOutlined} from "@ant-design/icons";
const AddButton =(props)=>{
    const {label,onAdd,fontSize,disabled,marginTop}=props
    return (
        <Button className={disabled?'add-button-disable':'add-btn'} disabled={disabled} style={{fontSize:fontSize,marginTop:marginTop}} onClick={()=>onAdd(true)}><PlusOutlined className='plus-icon'/>{label}</Button>
    )
}
export default AddButton